import React from 'react';

export const EmailLink = ({ email }) => (
  <a className="privacy-link" href={`mailto:${email}`}>
    {email}
  </a>
);
